import React from "react";
import { ModalProvider } from "./context/ModalContext";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Products from "./components/Products";
import TeamHistory from "./components/TeamHistory";
import Footer from "./components/Footer";
import Modal from "./components/Modal";
import BackToTop from "./components/BackToTop";
import "./styles/App.css";

function App() {
  return (
    <LanguageProvider>
      <ModalProvider>
        <div className="App">
          <Header />
          <Hero />
          <Services />
          <Products />
          <TeamHistory />
          <Footer />
          <Modal />
          <BackToTop />
        </div>
      </ModalProvider>
    </LanguageProvider>
  );
}

export default App;
